exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".welcome {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  padding: 30px;\n  height: 100%; }\n  .welcome__title {\n    text-align: center;\n    color: #fff;\n    font-size: 2em;\n    font-weight: bold; }\n  .welcome__logo {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n    align-items: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    width: 80px;\n    height: 80px;\n    background: #fff;\n    border-radius: 50%;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    margin-top: 30px; }\n    .welcome__logo img {\n      width: 70%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/AUTH_PAGE/components/Welcome/index.scss
// module id = 294
// module chunks = 0